import { Avatar, Col, Dropdown, Menu, Row, Tooltip, Button } from "antd";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  checkIsAdmin,
  checkIsEmployee,
  getLocalStorage,
  getValidLandingScreen,
} from "../../helpers/utils";

import images from "../../assets/images";
import { UserOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { logout } from "../../slices/signIn.slice";

const HeaderMenu = ({ showDrawer, isPreAssessmentScreen }) => {
  const dispatch = useDispatch();
  const userData = getLocalStorage("USER_DETAILS");
  const history = useHistory();
  const location = useLocation();
  const isEmployeeLoggedIn = checkIsEmployee();
  const onPlaybooks = location.pathname.startsWith("/playbooks");
  // Show Playbooks entry only outside the IR module (in-module nav is IrShell).
  const showPlaybooksNav =
    (checkIsAdmin() || checkIsEmployee()) && !onPlaybooks;

  const handleLogout = () => {
    dispatch(logout());
    localStorage.clear();
    history.replace("/");
  };

  const menu = (
    <Menu className="header-dropdown-warpper">
      <div className="header-dropdown-menu-items">
        <Row>
          <Col span={17} offset={1}>
            <div className="username-dropdown">
              {userData?.user_name ? userData?.user_name : userData?.name}
            </div>
            <div className="organization-dropdown">
              {userData?.organization}
            </div>
            <div className="email-dropdown">
              {userData?.user_email ? userData?.user_email : userData?.email}
            </div>
          </Col>
        </Row>
      </div>
      <Menu.Item
        className="header-options header-dropdown-menu-items divider"
        key="0"
        onClick={() => showDrawer("Edit Profile")}
      >
        Edit Profile
      </Menu.Item>
      <Menu.Item
        className="header-options header-dropdown-menu-items divider"
        key="1"
        onClick={() => showDrawer("Change Password")}
      >
        Change Password
      </Menu.Item>
      <Menu.Item
        className="header-options header-dropdown-menu-items"
        key="2"
        onClick={handleLogout}
      >
        Logout
      </Menu.Item>
    </Menu>
  );
  return (
    <Menu
      className="header-menu-bar"
      style={{
        marginLeft: "auto",
        backgroundColor: "transparent",
        padding: "0",
        position: "relative",
        height: "100%",
      }}
      selectable={false}
      theme="dark"
      mode="horizontal"
    >
      <Menu.Item
        className="navbar-logout-hover"
        key="1"
        onClick={() => history.push(getValidLandingScreen())}
      >
        <img
          src={
            isPreAssessmentScreen ? images.AssessmentAppLogo : images.AppLogo
          }
          className="app-logo"
          alt="CYBRBASE"
        />
      </Menu.Item>
      <Row justify="end" className="header-action-right">
        {showPlaybooksNav && (
          <Col className="header-playbooks-slot">
            <Button
              type="text"
              className="header-playbooks-btn"
              onClick={() => history.push("/playbooks")}
            >
              Incident Response Playbook
            </Button>
          </Col>
        )}
        {isEmployeeLoggedIn && (
          <Tooltip
            placement="bottom"
            title="Control Library"
            color={"#0F1117"}
            overlayInnerStyle={{ fontSize: "13px" }}
          >
            <Col className="library-menu navbar-logout-hover">
              <Menu.Item
                key="2"
                onClick={() =>
                  history.push({
                    pathname: "/employee-control-library",
                    state: {
                      isEmployeeView: true,
                    },
                  })
                }
              >
                <img
                  src={images.Icons_Employee_Control_Library}
                  alt="control-library-icon"
                />
              </Menu.Item>
            </Col>
          </Tooltip>
        )}
        <Col className="header-profile-slot">
          <Dropdown
            overlay={menu}
            trigger={["click"]}
            placement="bottomRight"
          >
            <button
              type="button"
              className="header-profile-chip"
              aria-label="Open account menu"
            >
              <span className="header-profile-chip__meta">
                <span className="username-text">
                  {userData
                    ? userData.user_name
                      ? userData.user_name.split(" ")[0]
                      : userData.name?.split(" ")[0]
                    : "Account"}
                </span>
                <span className="header-profile-chip__hint">Profile</span>
              </span>
              <Avatar size={36} icon={<UserOutlined />} />
            </button>
          </Dropdown>
        </Col>
      </Row>
    </Menu>
  );
};

export default HeaderMenu;
